import { render, staticRenderFns } from "./produced-goods.vue?vue&type=template&id=42617bd0&scoped=true"
import script from "./produced-goods.vue?vue&type=script&lang=js"
export * from "./produced-goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42617bd0",
  null
  
)

export default component.exports